<form class="go-form go-form--dark">
  <div class="go-container go-container--form go-container--reset">
    <div class="go-column go-column--50">
      <go-input
        [control]="firstName"
        key="first-name-input"
        label="First Name"
        placeholder="Jonny"
      ></go-input>
    </div>
    <div class="go-column go-column--50">
      <go-input
        [control]="lastName"
        key="last-name-input"
        label="Last Name"
        placeholder="Appleseed"
      ></go-input>
    </div>
    <div class="go-column go-column--100">
      <go-input
        [control]="email"
        inputType="email"
        key="email-input"
        label="Email"
        placeholder="your@email.com"
      ></go-input>
    </div>
    <div class="go-column go-column--100">
      <go-input
        [control]="password"
        inputType="password"
        key="password-input"
        label="Password"
        placeholder="**************"
      ></go-input>
    </div>
  </div>

  <div class="go-column go-column--100">
    <go-button
      buttonVariant="positive"
      (handleClick)="fakeSubmit()"
      [useDarkTheme]="true"
      #submitButton
    >
      Submit
    </go-button>
  </div>
</form>
